"use client";
import { useNavigate } from "react-router-dom";
import React from "react";
import { FaCar, FaBus, FaTruck } from "react-icons/fa";
import { GiForklift } from "react-icons/gi";
import "./LeftSideBar.css";

const CarMakersList = () => {
  const navigate = useNavigate();

  const makers = [
    "TOYOTA",
    "MITSUBISHI",
    "NISSAN",
    "HONDA",
    "MAZDA",
    "SUBARU",
    "BMW",
    "HINO",
    "SUZUKI",
    "AUDI",
    "MERCEDES",
    "VOLKSWAGEN",
    "ISUZU",
    "KOMATSU",
    "LEXUS",
    "DAIHATSU",
  ];

  const handleMakerClick = (maker) => {
    navigate(`/search?Make=${encodeURIComponent(maker)}`);
  };

  const getLogoPaths = (maker) => {
    const variations = [
      maker.toLowerCase(),
      maker.toUpperCase(),
      maker.charAt(0).toUpperCase() + maker.slice(1).toLowerCase(),
    ];

    const extensions = ["png", "jpg", "jpeg", "svg", "webp"];

    const paths = [];
    variations.forEach((variation) => {
      extensions.forEach((ext) => {
        paths.push(`/manufacturer_logo/${variation}.${ext}`);
      });
    });

    return paths;
  };

  const tryLoadLogo = (maker, imgElement, fallbackElement) => {
    const paths = getLogoPaths(maker);
    let currentIndex = 0;

    const tryNextPath = () => {
      if (currentIndex >= paths.length) {
        imgElement.style.display = "none";
        fallbackElement.style.display = "inline-block";
        return;
      }

      const currentPath = paths[currentIndex];

      imgElement.onload = () => {
        imgElement.style.display = "block";
        fallbackElement.style.display = "none";
      };

      imgElement.onerror = () => {
        currentIndex++;
        tryNextPath();
      };

      imgElement.src = currentPath;
    };

    tryNextPath();
  };

  const ManufacturerLogo = ({ maker }) => {
    const imgRef = React.useRef(null);
    const fallbackRef = React.useRef(null);

    React.useEffect(() => {
      if (imgRef.current && fallbackRef.current) {
        tryLoadLogo(maker, imgRef.current, fallbackRef.current);
      }
    }, [maker]);

    return (
      <div className="icon-container">
        <img
          ref={imgRef}
          alt={`${maker} logo`}
          className="manufacturer-logo"
          style={{ display: "none" }}
        />
        <FaCar
          ref={fallbackRef}
          className="icon fallback-icon"
          style={{ display: "inline-block" }}
        />
      </div>
    );
  };

  return (
    <div className="search-section">
      <h2>Search By Makers</h2>
      <ul className="search-list">
        {makers.map((maker, index) => (
          <li
            key={index}
            className="search-item"
            onClick={() => handleMakerClick(maker)}
          >
            <ManufacturerLogo maker={maker} />
            <span className="text">{maker}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const VehicleShapesList = () => {
  const navigate = useNavigate();
  const shapes = [
    "COUPE",
    "SEDAN",
    "HATCHBACK",
    "WAGON",
    "SUV",
    "BUS",
    "VAN",
    "TRUCK",
    "FORKLIFT",
    "Pick up Truck",
  ];

  const shapeIcons = {
    COUPE: <FaCar />,
    SEDAN: <FaCar />,
    HATCHBACK: <FaCar />,
    WAGON: <FaCar />,
    SUV: <FaCar />,
    BUS: <FaBus />,
    VAN: <FaBus />,
    TRUCK: <FaTruck />,
    FORKLIFT: <GiForklift />,
    "Pick up Truck": <FaTruck />,
  };

  const handleShapeClick = (shape) => {
    navigate(`/search?Category=${encodeURIComponent(shape)}`);
  };

  return (
    <div className="vehicle-shapes-container">
      <h2>Search By Shapes</h2>
      <ul className="shapes-list">
        {shapes.map((shape, index) => (
          <li
            key={index}
            className="shape-item"
            onClick={() => handleShapeClick(shape)}
          >
            <div className="shape-icon-container">{shapeIcons[shape]}</div>
            <span className="text">{shape}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default function LeftSideBar() {
  return (
    <div className="left-sidebar">
      <CarMakersList />
      <VehicleShapesList />
    </div>
  );
}
